import './ArticleBox.scss';

const ArticleBox = (() => {})();

export default ArticleBox;
